import { 
	User16,
} from '@carbon/icons';


export default [
	/* **** */
	{
		path: '/clients',
		redirect: '/clients/cards',
		layout: 'Admin',
		meta: {
			name: 'Клиенты',
			icon: User16,
		},
		menu: true,
		permissions: [ 'card_update' ],
		children: [
			{
				path: '/cards',
				component: 'ClientsCards',
				meta: {
					name: 'Карты',
				},
				menu: true,
				permissions: [ 'card_update' ],
			},
			{
				path: '/cards/:id',
				component: 'ClientsCardEdit',
				meta: {
					name: 'Карта клиента',
				},
				permissions: [ 'card_update' ],
			},
			{
				path: '/add',
				component: 'ClientsCardAdd',
				meta: {
					name: 'Добавить карту',
				},
				menu: true,
				permissions: [ 'card_create' ],
			},
		],
	},
	/* **** */
];
